import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccountService } from '../../../../services/account.service';
import { WatchAccountService } from '../../../../services/watch-account.service';

@Component({
  selector: '[account-todos-dashboard]',
  template: require('./account-todos-dashboard.component.pug'),
  styles: [require('./account-todos-dashboard.component.css').toString()],
})
export class AccountTodosDashboardComponent {
  sub: Subscription;
  reviews = 0;

  // -------------------------------------------------------------------
  constructor(
    private accountService: AccountService,
    private watchAccount: WatchAccountService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.sub = this.accountService
      .actions(this.watchAccount.accountId().getValue())
      .subscribe(account => {
        this.reviews = account.totalReviews;
      });
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
